// src/app/data.service.ts
import { Injectable, signal, WritableSignal } from '@angular/core';
import { enquiry, TrackingCoords } from '../models/enquiries';

// define a small shape that tracking-map provides
export type StopSummary = {
  id: number;
  data: { lat: number; lng: number };
  address?: string;
  index?: number;
};

@Injectable({ providedIn: 'root' })
export class trackingMapService {
  private sharedData = signal<enquiry | null>(null);
  private sharedEnquiryId = signal<string>('');

  // UI signals
  label: WritableSignal<string> = signal('Direction to pickup');
  show: WritableSignal<boolean> = signal(false);
  nextStop: WritableSignal<string | null> = signal(null);
  private _currentTargetIndex = signal<number | null>(null);
  currentTargetIndex = () => this._currentTargetIndex();

  private _completedStops = signal<StopSummary[]>([]);
  completedStops = () => this._completedStops();

  // click event counter. Incrementing this acts as an event bus.
  clickCount: WritableSignal<number> = signal(0);
  sos = signal(false);
  trackingCoords = signal<TrackingCoords | null>(null);

  // Public setters (used by TrackingMapComponent)
  setLabel(v: string) {
    this.label.set(v);
  }

  setShow(v: boolean) {
    this.show.set(v);
  }

  setNextStopAddress(v: string | null) {
    this.nextStop.set(v);
  }

  // Called by Button component to emit a click event
  emitButtonClick() {
    this.clickCount.update(n => n + 1);
  }

  updateDirectionIndex(index: number | null, stops?: StopSummary[]) {
    this._currentTargetIndex.set(index);

    if (typeof index === 'number' && stops && stops.length > 0) {
      const completed = stops[index];
      if (completed) {
        const exists = this._completedStops().some(s => s.id === completed.id);
        if (!exists) {
          this._completedStops.update(list => [...list, completed]);
        }
      }
    }
  }

  // DATA
  setData(newData: enquiry) {
    this.sharedData.set(newData);
  }

  getData() {
    return this.sharedData;
  }

  // ID

  setId(newData: string) {
    this.sharedEnquiryId.set(newData);
  }

  getId() {
    return this.sharedEnquiryId;
  }

  // SOS

  setSos(v: boolean) {
    this.sos.set(v);
  }

  getSos() {
    return this.sos;
  }

  // get Coordinates

  setCoordinates(v: any) {
    this.trackingCoords.set(v);
  }

  getCoordinates() {
    return this.trackingCoords;
  }
}
